export default __webpack_public_path__ + "fd45dc507c3a8552aa703412105ecd6d.png";